import { FormControlLabel, FormGroup, Switch } from '@mui/material';
import { VendorProfile } from '@trnsact/trnsact-shared-types';
import { useOcaTemplateConfigurationToggles } from 'hooks/useOcaTemplateConfigurationToggles';
import { useNotifications } from 'modules/notification';

interface Props {
  vendorProfile: VendorProfile;
}

export default function OcaTemplateConfigurationToggles({ vendorProfile }: Props) {
  const { showNotification } = useNotifications();

  const onUpdateSuccess = () => showNotification('OCA template has been successfully updated');

  const {
    isInsuranceModuleSetInOca,
    isWorkingCapitalModuleSetInOca,
    isLoading,
    handleAddOrRemoveOcaInsuranceModule,
    handleAddOrRemoveOcaWorkingCapitalModule,
  } = useOcaTemplateConfigurationToggles(vendorProfile.id, onUpdateSuccess);

  return (
    <FormGroup>
      <FormControlLabel
        disabled={isLoading}
        control={<Switch checked={isInsuranceModuleSetInOca} onChange={handleAddOrRemoveOcaInsuranceModule} />}
        label="Include Insurance Module in OCA"
      />

      <FormControlLabel
        disabled={isLoading}
        control={
          <Switch checked={isWorkingCapitalModuleSetInOca} onChange={handleAddOrRemoveOcaWorkingCapitalModule} />
        }
        label="Include Working Capital Module in OCA"
      />
    </FormGroup>
  );
}
